import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { ICountDown } from 'src/app/core/interfaces/shared/components/ICountDown';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-countdown',
  templateUrl: './globaldialog.component.html',
  styleUrls: ['./globaldialog.component.scss'],
})
export class GlobalDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICountDown,
    public dialogRef: MatDialogRef<GlobalDialogComponent>
  ) {}

  countDown: Subscription;
  timeToCountDown: number = environment.notify.timeout.seconds;
  intervalTime: number = 1000;

  ngOnInit() {
    this.countDownTimer();
  }

  retrySendNotifyToClient() {
    this.dialogRef.close({ action: 'resend_notify' });
  }

  countDownTimer() {
    this.countDown = timer(0, this.intervalTime).subscribe(() => {
      if (this.timeToCountDown != 0) {
        --this.timeToCountDown;
      } else {
        this.countDown.unsubscribe();
        this.dialogRef.close();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.countDown.unsubscribe();
  }
}
